import { queryClient } from '@/configs/tanstack'
import { api } from '@/utils/api'
import { apiBundles } from '@/utils/api/url'
import { useMutation } from '@tanstack/react-query'
import { App } from 'antd'
import { QUERY_KEY_GET_BUNDLES } from './useGetBundles'
import { BundlePayload } from '@/types/bundle'
import { useTranslation } from 'react-i18next'
const messageKey = 'create-bundle'

export const useCreateBundle = () => {
  const { t } = useTranslation('catalog')
  const { message } = App.useApp()
  const mutation = useMutation({
    mutationFn: ({ payload }: { payload: BundlePayload }) =>
      api
        .post(apiBundles, payload)
        .then(({ data }) => data as { message: string }),
    onMutate: () => {
      message.loading({
        key: messageKey,
        content: t('catalog.bundle.adding'),
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_GET_BUNDLES],
      })
      message.success({
        key: messageKey,
        content: t('catalog.bundle.added'),
      })
    },
    onError: () => {
      message.destroy(messageKey)
    },
  })

  return mutation
}
